import { useState, useEffect } from 'react';

const usePersistTheme = (key, initialState) => {
    const [state, setState] = useState(() => {
        try {
            const storageValue = localStorage.getItem(key)

            if (storageValue) {
                return JSON.parse(storageValue)
            }
        } catch (error) {
            console.error('Tema yüklenirken hata oluştu:', error)
            localStorage.removeItem(key)
        }

        return initialState
    })

    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(state))
        } catch (error) {
            console.error('Tema kaydedilirken hata oluştu:', error)
        }
    }, [key, state])

    return [state, setState]
}

export default usePersistTheme